export default __webpack_public_path__ + "static/media/NotoSansJP-Medium.1b7dde00.otf";